module.exports = __webpack_public_path__ + "assets/img/thumb-Super-Obvious-Video.13ceee7b.webp";